module.exports = __webpack_public_path__ + "img/jie_zidong.75153158.jpg";